/**
 * The station UI store (plan §2.8, §6 M2-18): a zustand vanilla store of `UiState & { actions }`. The career
 * runtime (M2-22) owns the actions and pushes snapshots with `setState`; the React screens only read it and call
 * the actions. No React import here, so the runtime and tests use it headless.
 */
import { createStore } from 'zustand/vanilla'
import type { UiActions, UiState, UiStore, UiStoreApi } from './contracts'

/** The state before the runtime pushes anything: no screen, no career, nothing loaded yet. */
export const initialUiState: Readonly<UiState> = Object.freeze({
  screen: 'none',
  tab: 'market',
  stationId: null,
  career: null,
  market: null,
  gameTime: 0,
  saves: [],
  storage: 'none',
  assetsReady: false,
  assetsProgress: 0,
  loading: false,
  notices: [],
  lastError: null,
  deathReport: null,
  confirm: null,
})

/** A fresh store over `actions`, starting from `initialUiState`. */
export function createUiStore(actions: UiActions): UiStoreApi {
  return createStore<UiStore>()(() => ({ ...initialUiState, saves: [], notices: [], actions }))
}
